module.exports = __webpack_public_path__ + "static/media/ATM.231664e6.svg";